import { getToken } from "@/helpers/auth-helper"
import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
    const token = getToken()

    return await axios.get(url, { params, headers: { Authorization: `Bearer ${token}` } }).then((res) => res.data.data)
}

const useCategoryRepos = (params) => {
    const { data, error, mutate, isValidating } = useSWR([`${process.env.REACT_APP_API_URL}/category`, params], ([url, params]) => fetcher(url, params))

    return {
        data,
        isLoading: !error && !data,
        error,
        isValidating,
        mutate
    }
}

export default useCategoryRepos